import RegularButton from '@/components/buttons/RegularButton'
import Divider from '@/components/divider/Divider'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid2'
import TextField from '@mui/material/TextField'
import React from 'react'
// @ts-expect-error It works
import HistoryPdf from '/documents/Handlingplan-Vid-Krankning.pdf'

const Contact: React.FC = () => {
  const [name, setName] = React.useState<string>('')
  const [email, setEmail] = React.useState<string>('')
  const [phone, setPhone] = React.useState<string>('')
  const [description, setDescription] = React.useState<string>('')
  const [isSending, setIsSending] = React.useState<boolean>(false)
  const [sendStatus, setSendStatus] = React.useState<
    'idle' | 'success' | 'error'
  >('idle')
  const maxDescriptionLength = 500

  const sendEmail = async () => {
    if (isSending) return

    setIsSending(true)
    setSendStatus('idle')
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        email,
        phoneNumber: phone,
        description,
      }),
    }
    try {
      const response = await fetch(
        `${window.env.API_ENDPOINT}/email/contact`,
        requestOptions,
      )
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      setSendStatus('success')
      setName('')
      setEmail('')
      setPhone('')
      setDescription('')
    } catch (error) {
      console.error('Error:', error)
      setSendStatus('error')
    } finally {
      setIsSending(false)
    }
  }

  return (
    <Grid
      container
      direction="column"
      spacing={2}
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Grid size={10}>
        <h1>Kontakt</h1>
      </Grid>

      {sendStatus === 'success' ? (
        <Grid size={{ xs: 11, md: 4 }}>
          <Alert severity="success" role="status" sx={{ textAlign: 'start' }}>
            Tack! Vi återkommer så snart vi kan.
          </Alert>
          <Button
            variant="contained"
            sx={{ mt: 3, color: '#FFFFFF' }}
            onClick={() => setSendStatus('idle')}
          >
            Skriv ett nytt meddelande
          </Button>
        </Grid>
      ) : (
        <Grid container spacing={2} size={{ xs: 11, md: 4 }}>
          {sendStatus === 'error' && (
            <Grid size={12}>
              <Alert severity="error" sx={{ textAlign: 'start' }}>
                Meddelandet kunde inte skickas. Försök igen om en stund.
              </Alert>
            </Grid>
          )}
          <Grid size={12}>
            <TextField
              required
              label="Namn"
              type="text"
              value={name}
              sx={{ width: '100%' }}
              onChange={(event) => setName(event.target.value)}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              required
              label="Email"
              type="email"
              value={email}
              sx={{ width: '100%' }}
              onChange={(event) => setEmail(event.target.value)}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              label="Telefonnummer"
              type="tel"
              value={phone}
              sx={{ width: '100%' }}
              onChange={(event) => setPhone(event.target.value)}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              required
              label="Beskrivning"
              type="text"
              multiline
              helperText={`${description.length} / ${maxDescriptionLength}`}
              rows={6}
              value={description}
              sx={{ width: '100%' }}
              onChange={(event) =>
                event.target.value.length <= maxDescriptionLength &&
                setDescription(event.target.value)
              }
            />
          </Grid>

          <Grid size={12} textAlign="end">
            <RegularButton
              label={
                <>
                  Skicka <ArrowForwardIcon />
                </>
              }
              aria-label="Skicka"
              isLoading={isSending}
              width={100}
              height={40}
              onClick={sendEmail}
            />
          </Grid>
        </Grid>
      )}

      <Divider size={{ xs: 11, md: 10 }} />

      <Grid
        size={{ xs: 11, md: 6 }}
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <h2>Kontaktuppgifter</h2>
        <p style={{ textAlign: 'start' }}>
          <b>Dirigent - Povel Andersson</b>, Nås enklast på telefon.
          <br />
          <b>Telefon:</b> 07-381 987 21
          <br />
          <b>Mail:</b> povel.andersson@gmail.com
        </p>

        {/* <p><b>Styrelsen:</b> telefon: xxxxxxxx mail: xxxxxxxx</p> */}
      </Grid>

      <Divider size={{ xs: 11, md: 10 }} />

      <Grid
        size={{ xs: 11, md: 6 }}
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <p>Handlingsplan vid kränkningar, trakasserier och mobbning</p>
        <a
          href={HistoryPdf}
          download="/documents/Karlshamns-Scoutmusikkårs-Historia.pdf"
          target="_blank"
          rel="noreferrer"
        >
          <Button
            variant="contained"
            sx={{
              color: '#FFFFFF',
              width: 150,
              height: 40,
              marginBottom: '20px',
            }}
          >
            <>
              Ladda ner <PictureAsPdfIcon />
            </>
          </Button>
        </a>
      </Grid>

      {/* <Divider size={{ xs: 11, md: 10 }}/>

      <Grid size={{ xs: 11, md: 10 }} sx={{ marginTop: '50px' }}>
        <Image src='/images/statics/groupimage-2024.jpg' alt="Grubbild" loading="eager" />
        <h3>Styrelsen</h3>
        <p><b>Sett ifrån vänster:</b> Per Thruedsson, Jojo Berghall</p>
      </Grid> */}
    </Grid>
  )
}

export default Contact
